module.exports = __webpack_public_path__ + "08ca0eed8dfd758050d79724516398cf.svg";